<template>
  <div class="login-page font-opensans height-fixed d-flex align-items-center justify-content-center">
    <div class="login-card shadow-lg">

      <!-- Panel izquierdo: marca -->
      <div class="brand-panel d-none d-md-flex">
        <div class="brand-overlay"></div>
        <div class="brand-content">
          <img :src="require('@/assets/logo-alianza.png')" alt="LOGIC" class="brand-logo">
          <p class="brand-tagline">Sistema de Gestión</p>
        </div>
      </div>

      <!-- Panel derecho: formulario -->
      <div class="form-panel">
        <!-- Logo visible solo en mobile -->
        <div class="text-center mb-4 d-md-none">
          <img :src="require('@/assets/logo-alianza.png')" alt="LOGIC" class="img-fluid mobile-logo">
        </div>

        <h2 class="form-title">Bienvenido</h2>
        <p class="form-subtitle">Inicia sesión para continuar</p>

        <b-form @submit.prevent="login" class="mt-4">
          <b-form-group class="mb-3">
            <b-input-group>
              <b-input-group-prepend is-text>
                <b-icon icon="person-fill" class="input-icon-color"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="email"
                type="text"
                placeholder="Usuario o Email"
                v-model="email"
                class="custom-field"
                autocomplete="username"
              />
            </b-input-group>
          </b-form-group>

          <b-form-group class="mb-4">
            <b-input-group>
              <b-input-group-prepend is-text>
                <b-icon icon="lock-fill" class="input-icon-color"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="password"
                type="password"
                placeholder="Contraseña"
                v-model="password"
                class="custom-field"
                autocomplete="current-password"
              />
            </b-input-group>
          </b-form-group>

          <b-button v-if="!cargando" type="submit" class="submit-btn w-100">
            Iniciar sesión
          </b-button>
          <div v-else class="text-center py-1">
            <b-spinner variant="warning"></b-spinner>
          </div>

          <b-alert v-if="error" show variant="danger" class="mt-3 mb-0 py-2 fs-12">
            <b-icon icon="exclamation-triangle-fill" class="me-1"></b-icon>
            {{ error }}
          </b-alert>
        </b-form>

        <div class="version-label">
          <span class="label-col-green fs-10">Versión {{ app.version }}</span>
        </div>
      </div>

    </div>
    <Modals ref="mod"></Modals>
  </div>
</template>

<script>
import Modals from '@/components/Modals.vue'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'LoginPage',
  components: { Modals },
  data() {
    return {
      cargando: false,
      email: '',
      password: '',
      error: '',
    };
  },
  computed: {
    ...mapState(['operador', 'modal', 'menu', 'app']),
  },
  methods: {
    ...mapActions(['actupdateMenu', 'actupdateModal']),
    showmodal(tittle, message) {
      this.modal.tittle = tittle
      this.modal.message = message
      this.modal.type = 0
      this.actupdateModal(this.modal)
      this.$refs.mod.showmodal()
    },
    login() {
      this.cargando = true
      const val = { operador: this.email, clave: this.password }
      this.$store.dispatch("isValidUser", val).then((resp) => {
        if (resp.estatus == 0) {
          this.error = resp.message
          this.showAlert()
          this.cargando = false
        } else {
          const op = resp.operador
          op.isAuthenticated = true
          this.$store.dispatch("actupdateOperador", op)
          if (resp.operador.perfil == "Dosificador") {
            this.$store.dispatch('actupdateMenu', { ruta: 'vpedidos', tittle: 'vPedidos' })
          } else {
            this.$store.dispatch('actupdateMenu', { ruta: 'vsolicitudes', tittle: 'vSolicitudes' })
          }
          this.$emit('login');
        }
      }).catch((err) => {
        this.showmodal(this.texto, err)
        this.cargando = false
      })
    },
    showAlert() {
      this.timer = setTimeout(() => { this.error = "" }, 5000);
    }
  }
};
</script>

<style scoped>
.login-page {
  background: linear-gradient(135deg, #e8f0f7 0%, #d0e4f5 100%);
  padding: 16px;
}

.login-card {
  display: flex;
  width: 100%;
  max-width: 780px;
  min-height: 480px;
  border-radius: 20px;
  overflow: hidden;
  background: #ffffff;
}

/* ── Panel izquierdo ── */
.brand-panel {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #0d2b5e 0%, #1a4d8f 55%, #316ea0 100%);
}

.brand-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 30% 70%, rgba(255,255,255,0.06) 0%, transparent 60%);
}

.brand-content {
  position: relative;
  text-align: center;
  padding: 40px 32px;
}

.brand-logo {
  width: 100%;
  max-width: 210px;
  filter: brightness(0) invert(1);
}

.brand-tagline {
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-top: 16px;
  margin-bottom: 0;
}

/* ── Panel derecho ── */
.form-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 40px 32px;
}

.form-title {
  font-size: 26px;
  font-weight: 700;
  color: #0d2b5e;
  margin-bottom: 4px;
}

.form-subtitle {
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 0;
}

/* Inputs */
.input-icon-color {
  color: #316ea0;
}

.custom-field {
  border-left: none !important;
  box-shadow: none !important;
}

.custom-field:focus {
  border-color: #316ea0 !important;
  box-shadow: none !important;
}

/* Fija el color del borde del prepend cuando el input tiene focus */
.input-group:focus-within .input-group-text {
  border-color: #316ea0;
}

/* Botón */
.submit-btn {
  background: linear-gradient(90deg, #0d2b5e, #316ea0) !important;
  border: none !important;
  border-radius: 50px !important;
  padding: 10px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  color: #ffffff !important;
  transition: opacity 0.2s ease, transform 0.15s ease !important;
}

.submit-btn:hover {
  opacity: 0.9 !important;
  transform: translateY(-1px) !important;
}

.submit-btn:active {
  transform: translateY(0) !important;
}

/* Logo mobile */
.mobile-logo {
  max-width: 180px;
}

/* Versión */
.version-label {
  margin-top: 24px;
  text-align: right;
}

/* Responsive: una sola columna en móvil */
@media (max-width: 767px) {
  .login-card {
    flex-direction: column;
    max-width: 420px;
    min-height: unset;
  }
  .form-panel {
    padding: 32px 28px 24px;
  }
}
</style>
